import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class RoleService {
    private _role = new BehaviorSubject<string>(this.getSavedRole());
    role$ = this._role.asObservable();

    private getSavedRole(): string {
        return localStorage.getItem('role') || '';
    }

    setRole(role: string) {
        localStorage.setItem('role', role);
        this._role.next(role);
    }

    getRole(): string {
        return this._role.value;
    }
}
